// number转中文大写
export function toDx(n) {
  switch (n) {
    case '0':
      return '零';
    case '1':
      return '壹';
    case '2':
      return '贰';
    case '3':
      return '叁';
    case '4':
      return '肆';
    case '5':
      return '伍';
    case '6':
      return '陆';
    case '7':
      return '柒';
    case '8':
      return '捌';
    case '9':
      return '玖';
    default:
      break
  }
}

// 格式化金额
export function formatNum(num) {
  let st1 = String(num); // 将浮点数转换为字符串
  let index = st1.indexOf('.'); // 取小数点下标
  if (index < 0) {
    return toThousands(num)
  }
  let st2 = st1.slice(0, index); // 将小数点前面的字符串截取出来
  let len = st2.length;
  if (len < 3) return st2.concat(st1.slice(index));
  let r = len % 3;
  return (r > 0 ?
    st2.slice(0, r) + ',' + st2.slice(r, len).match(/\d{3}/g).join() :
    st2.slice(r, len).match(/\d{3}/g).join())
    .concat(st1.slice(index));
}
export function toThousands(num) {
  let result = '', counter = 0;
  num = (num || 0).toString();
  for (let i = num.length - 1; i >= 0; i--) {
    counter++;
    result = num.charAt(i) + result;
    if (!(counter % 3) && i != 0) { result = ',' + result; }
  }
  return result;
}